import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ba5c8126")

_pushScopeId("data-v-ba5c8126")
const _hoisted_1 = {
  class: "icon",
  "aria-hidden": "true"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _createVNode("use", {
      "xlink:href": `#${$props.type}`
    }, null, 8, ["xlink:href"])
  ]))
})